<template>
  <metainfo>
    <template v-slot:title="{ content }">{{ content ? content : `Eco-boss` }}</template>
  </metainfo>

  <RouterView/>
</template>

<script>
import { useMeta } from 'vue-meta'

const getTitle = () => {
  return window.location.hostname === "xn----htbmfuthi8f2a.xn--p1ai"
  //|| window.location.hostname === "localhost"
      ? "Эко студия маникюра|Челябинск"
      : "Eco-boss"
}

export default {
  setup() {
    useMeta({
      title: getTitle(),
      htmlAttrs: { lang: 'ru', amp: true }
    })
  },
  name: 'App',
};
</script>